/* GCR · interfaccia comune (leggera, senza dipendenze)
   - <gcr-countdown>: conto alla rovescia unico per hero, bundle e offerte
   - pulsante "torna su"
   - barra di caricamento tra le pagine */

/* ---------- Conto alla rovescia ---------- */
if (!customElements.get('gcr-countdown')) {
  customElements.define('gcr-countdown', class extends HTMLElement {
    connectedCallback() {
      this.end = this.parseEnd();
      if (!this.end) return;
      this.q = {};
      for (const k of ['d', 'h', 'm', 's']) this.q[k] = this.querySelector(`[data-${k}]`);
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
      this.onVis = () => { if (!document.hidden) this.tick(); };
      document.addEventListener('visibilitychange', this.onVis);
    }
    // "AAAA-MM-GG HH:MM" nell'ora del negozio (data-tz es. +0100). Se manca, usa data-end in ms.
    parseEnd() {
      const local = (this.dataset.local || '').trim();
      if (local) {
        let iso = local.replace(' ', 'T');
        if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) iso += 'T23:59';
        if (/T\d{2}:\d{2}$/.test(iso)) iso += ':00';
        const tz = (this.dataset.tz || '').trim();
        const off = /^[+-]\d{4}$/.test(tz) ? tz.slice(0, 3) + ':' + tz.slice(3) : '';
        const t = Date.parse(iso + off);
        if (!Number.isNaN(t)) return t;
      }
      const ms = Number(this.dataset.end);
      return ms > 0 ? ms : 0;
    }
    tick() {
      const left = Math.max(0, this.end - Date.now());
      const s = Math.floor(left / 1000);
      const pad = (n) => String(n).padStart(2, '0');
      const set = (k, v) => { if (this.q[k] && this.q[k].textContent !== v) this.q[k].textContent = v; };
      set('d', String(Math.floor(s / 86400)));
      set('h', pad(Math.floor((s % 86400) / 3600)));
      set('m', pad(Math.floor((s % 3600) / 60)));
      set('s', pad(s % 60));
      if (left > 0) return;
      clearInterval(this.timer);
      if (this.dataset.done) {
        this.innerHTML = '';
        const p = document.createElement('span');
        p.className = 'gcr-countdown__done';
        p.textContent = this.dataset.done;
        this.append(p);
      }
      if (this.dataset.hide === 'true' && !window.Shopify?.designMode) this.closest('.shopify-section')?.setAttribute('hidden', '');
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.onVis);
    }
  });
}

/* ---------- Torna su ---------- */
(() => {
  const btn = document.querySelector('[data-gcr-top]');
  if (!btn) return;
  const ring = btn.querySelector('[data-gcr-top-ring]');
  let ticking = false;
  const update = () => {
    ticking = false;
    const max = document.documentElement.scrollHeight - innerHeight;
    const y = scrollY;
    btn.classList.toggle('is-on', y > Math.min(700, innerHeight * 0.9));
    if (ring) ring.style.transform = `scaleX(${max > 0 ? Math.min(1, y / max) : 0})`;
  };
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
  addEventListener('resize', update, { passive: true });
  addEventListener('pageshow', update);
  update();
  btn.addEventListener('click', () => {
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    const target = document.querySelector('#MainContent');
    setTimeout(() => target?.focus?.({ preventScroll: true }), reduce ? 0 : 600);
  });
})();

/* ---------- Barra di caricamento tra le pagine ---------- */
(() => {
  const bar = document.querySelector('[data-gcr-loader]');
  if (!bar || window.Shopify?.designMode) return;
  let timer;
  const start = () => {
    clearTimeout(timer);
    bar.classList.remove('is-done');
    // parte solo se la pagina tarda più di 120 ms: niente lampi sulle pagine veloci
    timer = setTimeout(() => bar.classList.add('is-loading'), 120);
  };
  const reset = () => { clearTimeout(timer); bar.classList.remove('is-loading', 'is-done'); };
  document.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest?.('a[href]');
    if (!a || a.target && a.target !== '_self' || a.hasAttribute('download')) return;
    if (a.closest('[data-no-loader], dialog, cart-drawer-component')) return;
    const url = new URL(a.href, location.href);
    if (url.origin !== location.origin) return;
    if (url.pathname === location.pathname && url.search === location.search) return; // ancore e stessa pagina
    if (/\/(cart\/(add|change|clear)|account\/logout)/.test(url.pathname)) return;
    // lascia al click il tempo di essere gestito da altri script (carrello, drawer…)
    requestAnimationFrame(() => { if (!e.defaultPrevented) start(); });
  });
  document.addEventListener('submit', (e) => {
    const f = e.target;
    if (e.defaultPrevented || !(f instanceof HTMLFormElement)) return;
    if ((f.getAttribute('action') || '').includes('/search')) start();
  });
  addEventListener('pageshow', reset);
  addEventListener('pagehide', () => { clearTimeout(timer); bar.classList.add('is-done'); });
})();

/* ---------- Ingressi editoriali (tutto il sito) ----------
   Un solo sistema, coerente ovunque:
   - testo (occhielli, titoli, paragrafi chiave): sale di 18px e appare
   - schede (libri, bundle, recensioni, articoli, collezioni, colonne del footer): idem, in sequenza
   - foto grandi: si svelano dall'alto con un leggero zoom che si assesta
   Solo ciò che sta sotto la piega: quello già visibile all'apertura non si tocca (niente lampi,
   niente contenuti nascosti se lo script non parte). Un solo IntersectionObserver, solo opacity,
   transform e clip-path. Spento con "riduci movimento" e nell'editor del tema. */
(() => {
  if (window.Shopify?.designMode || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const GROUPS = [
    ['text', [
      '.gcr-kicker', '.gcr-heading__title', '.gcr-intro', '.gcr-bundles__title', '.gcr-bundles__text', '.gcr-bundles__strip',
      '.gcr-faq__title', '.gcr-faq__text', '.gcr-blog__title', '.gcr-blog__intro', '.gcr-pmq__title', '.gcr-hero__title',
      '.gcr-hero__dek', '.gcr-hero__buy', '.gcr-month__banner', '.gcr-statement__text', '.gcr-statement__sign',
      '.gcr-news__grid > div', '.gcr-gal__head', '.gcr-yt__channel', '.gcr-yt__head', '.gcr-band__content > *',
      '.gcr-article__head > *', '.gcr-article__body > *', '.gcr-article__book', '.gcr-front__head', '.gcr-front__dek',
      'h2.h2', '.text-block', '.collection-header', '.gcr-footer__legal', '.gcr-author__head > *', '.gcr-tl__title', '.gcr-themes__head > *', '.gcr-works__head'
    ].join(',')],
    ['card', [
      '.gcr-tier', '.gcr-quote', '.gcr-clip', '.gcr-promise', '.gcr-post', '.gcr-person', '.gcr-yt__card', '.gcr-shelf__item',
      '.gcr-faq__item', '.gcr-tl__item', '.gcr-works__item', '.gcr-theme', '.product-grid__item', '.resource-list__item', '.gcr-footer__brand', '.gcr-footer__col', '.gcr-footer__aside'
    ].join(',')],
    ['media', '.gcr-band__media, .gcr-hero__media, .gcr-article__media, .gcr-front__figure, .gcr-author__photo']
  ];
  const SKIP = '.gcr-ss-scene, .gcr-pmq, dialog, header, cart-drawer-component, .product-details, .product-information__media, [data-gcr-intro], [data-gcr-front-intro], .gcr-gal__grid, .gcr-rail .gcr-rail';
  const io = new IntersectionObserver((entries) => {
    // in sequenza quelli che entrano insieme (una riga di libri, tre bundle…)
    const hits = entries.filter((e) => e.isIntersecting).sort((a, b) => (a.boundingClientRect.top - b.boundingClientRect.top) || (a.boundingClientRect.left - b.boundingClientRect.left));
    hits.forEach((e, i) => {
      const el = e.target;
      el.style.setProperty('--rv-d', `${Math.min(i, 6) * 80}ms`);
      el.classList.add('is-in');
      io.unobserve(el);
      // a fine animazione si tolgono le classi: hover e layout tornano esattamente quelli del tema
      setTimeout(() => el.classList.remove('gcr-rv', 'gcr-rv--text', 'gcr-rv--card', 'gcr-rv--media', 'is-in'), 1900 + Math.min(i, 6) * 80);
    });
  }, { rootMargin: '0px 0px -7% 0px' });
  const fold = innerHeight * 0.9;
  const scan = (root) => {
    for (const [kind, sel] of GROUPS) {
      root.querySelectorAll(sel).forEach((el) => {
        if (el.dataset.gcrRv || el.closest(SKIP) || el.parentElement?.closest('.gcr-rv')) return;
        el.dataset.gcrRv = '1';
        const r = el.getBoundingClientRect();
        if (!r.height || r.top < fold) return;
        el.classList.add('gcr-rv', 'gcr-rv--' + kind);
        io.observe(el);
      });
    }
  };
  const run = () => { scan(document.getElementById('MainContent') || document.body); const f = document.querySelector('footer'); if (f) scan(f); };
  if (document.readyState === 'complete') run(); else addEventListener('load', run, { once: true });
  // contenuti aggiunti dopo (prodotti consigliati, "carica altri" nelle collezioni)
  document.addEventListener('shopify:section:load', run);
  addEventListener('pageshow', (e) => { if (e.persisted) document.querySelectorAll('.gcr-rv').forEach((el) => el.classList.add('is-in')); });
})();

/* ---------- Leggi un estratto (scheda libro) ---------- */
if (!customElements.get('gcr-excerpt')) {
  customElements.define('gcr-excerpt', class extends HTMLElement {
    connectedCallback() {
      this.dlg = this.querySelector('[data-excerpt-dlg]');
      this.pos = this.querySelector('[data-excerpt-pos]');
      const pages = [...this.querySelectorAll('.gcr-excerpt__page')];
      this.querySelector('[data-excerpt-open]')?.addEventListener('click', () => {
        this.dlg.showModal();
        document.documentElement.classList.add('gcr-gal-open');
        this.dlg.querySelector('[data-excerpt-pages]').scrollTop = 0;
      });
      this.querySelector('[data-excerpt-close]')?.addEventListener('click', () => this.dlg.close());
      this.dlg.addEventListener('close', () => document.documentElement.classList.remove('gcr-gal-open'));
      this.dlg.addEventListener('click', (e) => { if (e.target === this.dlg) this.dlg.close(); });
      const stop = (e) => { if (e.target.closest('.gcr-excerpt__page')) e.preventDefault(); };
      this.dlg.addEventListener('contextmenu', stop);
      this.dlg.addEventListener('dragstart', stop);
      if ('IntersectionObserver' in window && this.pos) {
        const io = new IntersectionObserver((ens) => {
          for (const en of ens) if (en.isIntersecting) this.pos.textContent = String(pages.indexOf(en.target) + 1);
        }, { root: this.dlg.querySelector('[data-excerpt-pages]'), threshold: 0.5 });
        pages.forEach((p) => io.observe(p));
      }
    }
  });
}

/* ---------- Spedizione gratuita nella scheda libro ---------- */
if (!customElements.get('gcr-ship-progress')) {
  customElements.define('gcr-ship-progress', class extends HTMLElement {
    connectedCallback() {
      this.goal = Number(this.dataset.goal) || 0;
      this.price = Number(this.dataset.price) || 0;
      this.productId = Number(this.dataset.product);
      this.state = { total: Number(this.dataset.total) || 0, count: Number(this.dataset.count) || 0, inCart: this.dataset.inCart === 'true' };
      this.render();
      this.onCart = (e) => this.fromCart(e.detail);
      document.addEventListener('gcr:cart', this.onCart);
      // il negozio può servire la pagina dalla cache: si riallinea al carrello vero, con calma
      const sync = () => fetch((window.Theme?.routes?.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((c) => this.fromCart(c)).catch(() => {});
      ('requestIdleCallback' in window ? requestIdleCallback : setTimeout)(sync);
    }
    disconnectedCallback() { document.removeEventListener('gcr:cart', this.onCart); }
    fromCart(cart) {
      if (!cart) return;
      this.state = { total: cart.total_price || 0, count: cart.item_count || 0, inCart: (cart.items || []).some((i) => i.product_id === this.productId) };
      this.render();
    }
    money(cents) {
      const fmt = this.dataset.format || '€{{amount_with_comma_separator}}';
      const n = (cents / 100).toFixed(2);
      const [i, d] = n.split('.');
      const dots = i.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      const commas = i.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => ({
        amount: `${commas}.${d}`,
        amount_no_decimals: commas,
        amount_with_comma_separator: `${dots},${d}`,
        amount_no_decimals_with_comma_separator: dots,
        amount_with_apostrophe_separator: `${i.replace(/\B(?=(\d{3})+(?!\d))/g, "'")}.${d}`
      }[k] ?? `${dots},${d}`));
    }
    render() {
      const { total, count, inCart } = this.state;
      this.hidden = count === 0 || !this.goal;
      if (this.hidden) return;
      const after = inCart ? total : total + this.price;
      const msg = this.querySelector('[data-shipp-msg]');
      if (total >= this.goal) msg.textContent = 'La spedizione del tuo ordine è già gratuita.';
      else if (inCart) msg.innerHTML = `Questo libro è già nel carrello: ti mancano <strong>${this.money(this.goal - total)}</strong> per la spedizione gratuita.`;
      else if (after >= this.goal) msg.innerHTML = 'Con questo libro <strong>la spedizione diventa gratuita</strong>.';
      else msg.innerHTML = `Con questo libro ti mancano <strong>${this.money(this.goal - after)}</strong> per la spedizione gratuita.`;
      this.classList.toggle('is-free', after >= this.goal);
      const clamp = (x) => Math.max(0, Math.min(1, x));
      this.querySelector('[data-shipp-now]').style.transform = `scaleX(${clamp(total / this.goal)})`;
      this.querySelector('[data-shipp-add]').style.transform = `scaleX(${clamp(after / this.goal)})`;
      this.querySelector('[data-shipp-cart]').textContent = `Nel carrello: ${count} ${count === 1 ? 'articolo' : 'articoli'} · ${this.money(total)}`;
    }
  });
}
